import { render, staticRenderFns } from "./RatingsToPerform.vue?vue&type=template&id=7b487dde"
import script from "./RatingsToPerform.vue?vue&type=script&lang=js"
export * from "./RatingsToPerform.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/myskilliz_new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b487dde')) {
      api.createRecord('7b487dde', component.options)
    } else {
      api.reload('7b487dde', component.options)
    }
    module.hot.accept("./RatingsToPerform.vue?vue&type=template&id=7b487dde", function () {
      api.rerender('7b487dde', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/views/rh/gestion/rating/partials/RatingsToPerform.vue"
export default component.exports